import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToTop } from '../../utils/scrollToTop';

/** Scroll to top whenever the route changes (full page navigation). */
const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();

  useLayoutEffect(() => {
    scrollToTop();
  }, [pathname, search, hash]);

  return null;
};

export default ScrollToTop;
